/* eslint-disable no-console */
/* eslint-disable no-underscore-dangle */
import { MenuTools, Wrap } from './styles';

import ChangeMosaic from '../ChangeMosaic';
import SideBySide from '../SideBySide';

import ButtonTooltip from '@map/components/ToolBar/components/ButtonTooltip';
/**
 * Tooltip é uma ferramenta utilizada para especificar informações extras
 * sobre algo quando o usuário move o ponteiro do mouse sobre um elemento.
 */
import Tooltip from 'components/Tooltip';
/**
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 * 
 * useEffect é um hook que permite executar efeitos colaterais em
 * seus componentes, por exemplo: buscar dados, atualizar diretamente
 * o DOM e cronômetros, ele aceita dois argumentos o segundo é opcional.
 */
import { useState, useEffect } from 'react';
/**
 *  useModules é responsavel por gerenciar os modulos do GeoBahia,
 *  todos os módulos criados na ADM.
 */
import { useModule } from 'views/MapView/hooks';

/**
 * Ferramenta de Analise
 * 
 * @param {string} mapContext Context
 * @param {boolean} isActive Verificação
 * @param {boolean} setIsActive Seta o estado
 * @returns Um menu onde esta a ferramenta buffer
 */
export const RemoteAnalysisTools = ({ mapContext, isActive, setIsActive }) => {
    const [activeTool, setActiveTool] = useState(null);

    // Estados de SUBMENU
    const [anchorToolOptions, setAnchorToolOptions] = useState(null);

    useEffect(() => {
        if (!isActive) setAnchorToolOptions(null);
    }, [isActive]);

    const { getElement, activeModule } = useModule();

    const handleActiveTool = (toolName) => {
        setActiveTool(activeTool === toolName ? null : toolName);
    };

    // Observando se a ferramenta está ativa
    useEffect(() => {
        if (isActive) {
            setActiveTool(null);
        }
    }, [isActive]);

    const Icon = (props) => (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M3.125 2.625H10.125V9.625H3.125V2.625ZM11.875 2.625H18.875V9.625H11.875V2.625ZM3.125 11.375H10.125V18.375H3.125V11.375ZM14.5 11.375H16.25V14H18.875V15.75H16.25V18.375H14.5V15.75H11.875V14H14.5V11.375ZM13.625 4.375V7.875H17.125V4.375H13.625ZM4.875 4.375V7.875H8.375V4.375H4.875ZM4.875 13.125V16.625H8.375V13.125H4.875Z"
                fill="#BEC7DC"
            />
        </svg>
    );

    return (
        <Wrap>
            <ButtonTooltip
                tooltip={RemoteAnalysisTools.properties.alias}
                description={RemoteAnalysisTools.properties.description}
                onClick={(e) => {
                    setIsActive(!isActive);
                    setAnchorToolOptions(anchorToolOptions ? null : e.currentTarget);
                }}
                tooltipDisabled={isActive}
                active={isActive}
            >
                <Icon width="24" height="24" />
            </ButtonTooltip>
            <MenuTools className={`${isActive && 'active'}`}>
                {activeModule &&
                    getElement(RemoteAnalysisTools.properties.id)?.configuracao.changeMosaic !== false && (
                        <div className="tool">
                            <Tooltip>
                                <ChangeMosaic
                                    mapContext={mapContext}
                                    isActive={isActive && activeTool === 'CPN-TB-RA-CHANGE-MOSAIC'}
                                    setIsActive={() => handleActiveTool('CPN-TB-RA-CHANGE-MOSAIC')}
                                />
                            </Tooltip>
                        </div>
                    )
                }
                {activeModule &&
                    getElement(RemoteAnalysisTools.properties.id)?.configuracao.sideBySide !== false && (
                        <div className="tool">
                            <Tooltip>
                                <SideBySide
                                    mapContext={mapContext}
                                    isActive={isActive && activeTool === 'CPN-TB-RA-SIDE-BY-SIDE'}
                                    setIsActive={() => handleActiveTool('CPN-TB-RA-SIDE-BY-SIDE')}
                                />
                            </Tooltip>
                        </div>
                    )
                }
            </MenuTools>
        </Wrap>
    );
};

RemoteAnalysisTools.properties = {
    id: 'CPN-TB-RA-REMOTE-ANALYSIS-TOOLS',
    alias: 'Ferramentas de Análise Remota',
    description: 'Conjunto de ferramentas para auxiliar na análise remota de procedimentos.',
    configurable: true,
};

export default RemoteAnalysisTools;
